// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"591ba096","271":"40a982a2","283":"dbddf6ae","381":"6d81118c","663":"9302e4e7","722":"6f4b6cb1","760":"e0aec1db","762":"20567818","830":"808f94a2","985":"aa05caab"}[chunkId] + ".chunk.css";
};